import axios from "axios";

const publicAxiosInstance = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// No auth interceptors for public API calls - purely anonymous requests
publicAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Still handle 401 but don't logout (public routes)
    return Promise.reject(error);
  },
);

export default publicAxiosInstance;
